<template>
  <t-text-field
    :id="field"
    v-model="value"
    v-bind="{ ...$attrs }"
    :class="[`field-${field}`]"
    :error-messages="errors"
    :placeholder="placeholder"
    outlined
    :autofocus="autofocus"
    :loading="loading"
    :success="isValid"
    @blur="validate(value)"
  />
</template>

<script>
import ValidationError from 'chimera/all/functions/ValidationError'
import AbstractFormField from 'chimera/all/components/form/fields/AbstractFormField'

export const field = 'address-number'
export default {
  name: 'AddressNumberField',

  extends: AbstractFormField,

  props: {
    field: {
      type: String,
      default: field,
    },

    autofocus: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: 'Huisnr',
    },
  },

  data: () => ({
    value: '',
  }),

  methods: {
    /**
     * @returns {*[]}
     */
    customErrorMap() {
      return [
        {
          id: ValidationError.reasonIsRequired,
          message: this.$i18n.t('field.address-number.validation.required'),
        },
        {
          id: ValidationError.reasonInvalidRegex,
          message: this.$i18n.t('field.address-number.validation.invalid'),
        },
        {
          id: ValidationError.reasonInvalidLength,
          message: this.$i18n.t('field.address-number.validation.invalid'),
        },
        {
          id: ValidationError.reasonInvalidValue,
          message: this.$i18n.t('field.address-number.validation.invalid'),
        },
      ]
    },
  },
}
</script>
